export default __webpack_public_path__ + "static/media/Group9186.2447f05b.svg";